import { useNavigate } from "react-router-dom";
import { Calendar, MapPin } from "lucide-react";
import SectionHead from "@/components/home/SectionHead";

export default function UpcomingSchedule({ upcoming }) {
  const navigate = useNavigate();
  const items = upcoming || [];
  return (
    <section data-testid="upcoming-schedule-card">
      <SectionHead title="Upcoming" onSee={() => navigate("/play")} seeLabel="View Schedule" seeTestid="view-schedule-btn" />
      <div className="rounded-2xl bg-white border border-[#0E395F]/10 divide-y divide-[#0E395F]/5">
        {items.map((e) => (
          <div key={e.event_id} data-testid="upcoming-match-item" className="flex items-center gap-3 p-4">
            <div className="grid place-items-center h-11 w-11 rounded-xl bg-[#BED445]/20 text-[#0E395F]"><Calendar size={18} /></div>
            <div className="flex-1 min-w-0">
              <div className="font-bold pv-text-dark text-sm">{e.title}</div>
              <div className="text-xs text-[#5C7285] inline-flex items-center gap-1"><MapPin size={11} />{e.location}</div>
            </div>
            <div className="text-right">
              <div className="text-xs font-bold pv-text-dark">{e.day}</div>
              <div className="text-xs text-[#5C7285]">{e.time}</div>
            </div>
          </div>
        ))}
        {!items.length && <div className="p-4 text-sm text-[#5C7285]">No upcoming sessions yet.</div>}
      </div>
    </section>
  );
}
